export const ADVANCES_REQUEST_PENDING = 'advances_request_pending';
export const ADVANCES_REQUEST_RECEIVED = 'advances_request_received';
export const ADVANCES_REQUEST_ERROR = 'advances_request_error';
